module.exports = __webpack_public_path__ + "img/5.847353ec.png";